import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinSumaCalculation'
})
export class JoinSumaCalculationPipe implements PipeTransform {
  transform(detailsHeader: string, data: any[], propertyName: string): string {
    const suma = data.reduce((total, item) => (total * 100 + (item[propertyName] || 0) * 100) / 100, 0);

    return `${detailsHeader} (${suma.toFixed(2)})`;
  }
}
